import type { BodyConfigRequest } from '@pba/react-utils';
import type { paths } from '@pba/types-openapi-node';
import { type ApiClientResponse, nodeApiClient, nodeApiRoutes } from 'common/services';

export type CreateEventQueryParams = paths['/events']['post']['parameters']['query'];
export type CreateEventRequestData = paths['/events']['post']['requestBody']['content']['application/json'];
type CreateEventResponseData = paths['/events']['post']['responses']['201']['content']['application/json'];

export const createEvent = async ({
  body,
  config,
}: BodyConfigRequest<CreateEventRequestData, CreateEventQueryParams>) =>
  nodeApiClient.post<CreateEventResponseData, ApiClientResponse<CreateEventResponseData>>(
    nodeApiRoutes.events.create,
    body,
    config,
  );
